import { createClientEventReporter, type ReportClientEvent } from '@agnivo/app-core';
import { appConfig } from '../config';
import { getLiveAccessToken } from '../auth/liveAccessToken';

/**
 * Module-scope Class-1 reporter — the seam `miniappTguidMissingSender.ts`'s
 * former `NO_CLASS_1_REPORTER` was waiting on
 * (`backlog/done/2026-09-18-frontend-mini-app-has-no-class-1-telemetry-reporter.md`).
 * Same eager-singleton shape as that file: mini-app's `appConfig` is a static
 * module constant, so there is no per-render reactivity to gain from building
 * this via `useMemo`/`useAppConfig()` the way `ApiProvider` does for the
 * shell-agnostic packages. `getLiveAccessToken` is the bridge to the one part
 * of this that IS live — the session's bearer, which does not exist yet at
 * module-eval time and only starts answering once `useTelegramInitDataAuth`
 * mounts and registers it (`../auth/liveAccessToken.ts`).
 *
 * Never throws: mirrors `buildRouteViewSender`'s guard — `createClientEventReporter`
 * calls `buildUrl` internally, which throws on a malformed `apiBaseUrl`. A throw
 * at module-eval time here would break every consumer that transitively imports
 * this file, which is strictly worse than the fire-and-forget failure this
 * exists to avoid.
 */
function build(): ReportClientEvent {
  try {
    return createClientEventReporter({
      apiMode: appConfig.apiMode,
      baseUrl: appConfig.apiBaseUrl,
      surface: appConfig.surface,
      getAccessToken: getLiveAccessToken,
    });
  } catch {
    return () => {};
  }
}

export const reportClientEvent: ReportClientEvent = build();
